module.exports = __webpack_public_path__ + "img/w-cutBag02.8fb17021.jpg";